module.exports = __webpack_public_path__ + "static/media/receiptFirstPage.61921b1f.png";